import { Outlet } from 'react-router-dom';

export function WmgOneLayout() {
  return (
    <div className="flex w-full flex-1 overflow-auto bg-gradient bg-[length:100%,auto] bg-fixed bg-no-repeat bg-level-01/full">
      <Outlet />
    </div>
  );
}

WmgOneLayout.displayName = 'WmgOneLayout';
